import { Tier3RowActions } from '@openx/constants/rowActions.ts';
import type { RowActionProps } from '@openx/types/tableHelpers.ts';
import { sortMenuButtonItems } from '@openx/utils/lib/tableHelpers.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../../components/AuthContext/context.ts';
import { isMasterOrganisation } from '../../../../permissions/validators.ts';
import type { CuratedDealBuyerDiscountApi } from '../../../../types/curatedDealBuyerDiscount.ts';
import { useCuratedDealBuyerDiscountDelete } from '../../hooks/useCuratedDealBuyerDiscountDelete.tsx';

export const useCuratedDealBuyerDiscountRowActions = () => {
  const { session } = useAuth();
  const { deleteCuratedDealBuyerDiscount } = useCuratedDealBuyerDiscountDelete();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isMasterOrg = isMasterOrganisation(session);

  return useMemo<RowActionProps<CuratedDealBuyerDiscountApi>[] | undefined>(() => {
    if (isMasterOrg) {
      return undefined;
    }

    return sortMenuButtonItems<CuratedDealBuyerDiscountApi>({
      [Tier3RowActions.Delete]: {
        danger: true,
        'data-test': 'delete',
        label: t('Delete'),
        onClick: curatedDealBuyerDiscount => deleteCuratedDealBuyerDiscount(curatedDealBuyerDiscount),
      },
      [Tier3RowActions.Edit]: {
        'data-test': 'edit',
        label: t('Edit'),
        onClick: ({ uid }) => navigate(`/discounts/${uid}/edit`),
      },
    });
  }, [deleteCuratedDealBuyerDiscount, isMasterOrg, navigate, t]);
};
